import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import { ProxyRequestParams } from "./types";

export * from "./types";

const ENDPOINTS = {
  PROXY:
    "/api/v1/org/:organization_id/integrations/:integration_id/proxy/:path",
};

export class ProxyAPI {
  constructor(private client: CohesiveAPIClient) {}

  async request<T = any>(
    params: ProxyRequestParams,
    config?: AxiosRequestConfig,
  ): Promise<T> {
    const organizationId = await this.client.getOrgID();
    const { integrationId, path, method, body, queryParams } = params;

    const url = route(ENDPOINTS.PROXY, {
      organization_id: organizationId,
      integration_id: integrationId,
      path,
    });

    const response = await this.client.axios.request<T>({
      method,
      url,
      data: body,
      params: queryParams,
      ...config,
    });

    return response.data;
  }
}
